/**
 * Editor do reajuste por TIPO (Índice | Percentual fixo | Sem reajuste | Outro),
 * portado da DEMO-03 (telas/Reajuste.tsx). Só os campos do tipo escolhido
 * aparecem e são exigidos. Usado na condição padrão do Parceiro de Locação e
 * na oferta de Locação (herdada e ajustável).
 */
import { INDICES_REAJUSTE, PERIODICIDADES_REAJUSTE, TIPOS_REAJUSTE, type Reajuste, type TipoReajuste } from '../../../backend/src/compartilhado/comercial.ts';

export function EditorReajuste({ valor, aoMudar, teste, desabilitado, compacto }: { valor: Reajuste; aoMudar: (r: Reajuste) => void; teste: string; desabilitado?: boolean; compacto?: boolean }) {
  const set = (patch: Partial<Reajuste>) => aoMudar({ ...valor, ...patch });
  const periodicidade = (
    <label>
      Periodicidade
      <select value={valor.periodicidade ?? ''} disabled={desabilitado} onChange={(e) => set({ periodicidade: e.target.value })} data-teste={`${teste}-periodicidade`}>
        <option value="">Selecione…</option>
        {PERIODICIDADES_REAJUSTE.map((p) => (
          <option key={p}>{p}</option>
        ))}
      </select>
    </label>
  );
  return (
    <div className={`editor-reajuste${compacto ? ' compacto' : ''}`} data-teste={teste}>
      <label>
        Tipo de reajuste
        <select
          value={valor.tipo}
          disabled={desabilitado}
          onChange={(e) => {
            const tipo = e.target.value as TipoReajuste;
            // Troca de tipo: mantém a periodicidade quando fizer sentido; o resto recomeça.
            aoMudar(tipo === 'Índice' ? { tipo, indice: valor.indice ?? '', periodicidade: valor.periodicidade, dataBase: valor.dataBase } : tipo === 'Percentual fixo' ? { tipo, percentual: valor.percentual, periodicidade: valor.periodicidade, dataBase: valor.dataBase } : tipo === 'Outro' ? { tipo, descricao: valor.descricao ?? '' } : { tipo });
          }}
          data-teste={`${teste}-tipo`}
        >
          {TIPOS_REAJUSTE.map((t) => (
            <option key={t}>{t}</option>
          ))}
        </select>
      </label>
      {valor.tipo === 'Índice' && (
        <>
          <label>
            Índice
            <select value={valor.indice ?? ''} disabled={desabilitado} onChange={(e) => set({ indice: e.target.value })} data-teste={`${teste}-indice`}>
              <option value="">Selecione…</option>
              {INDICES_REAJUSTE.map((i) => (
                <option key={i}>{i}</option>
              ))}
            </select>
          </label>
          {valor.indice === 'Outro' && (
            <label>
              Nome do índice
              <input value={valor.indiceOutro ?? ''} disabled={desabilitado} onChange={(e) => set({ indiceOutro: e.target.value })} data-teste={`${teste}-indice-outro`} />
            </label>
          )}
          {periodicidade}
          <label>
            Data-base ou regra
            <input value={valor.dataBase ?? ''} disabled={desabilitado} onChange={(e) => set({ dataBase: e.target.value })} placeholder="ex.: aniversário do contrato" data-teste={`${teste}-data-base`} />
          </label>
        </>
      )}
      {valor.tipo === 'Percentual fixo' && (
        <>
          <label>
            Percentual (%)
            <input type="number" min={0} step="0.1" value={valor.percentual ?? ''} disabled={desabilitado} onChange={(e) => set({ percentual: e.target.value === '' ? undefined : Number(e.target.value) })} data-teste={`${teste}-percentual`} />
          </label>
          {periodicidade}
        </>
      )}
      {valor.tipo === 'Outro' && (
        <label className="reajuste-descricao">
          Regra do reajuste
          <input value={valor.descricao ?? ''} disabled={desabilitado} onChange={(e) => set({ descricao: e.target.value })} placeholder="Descreva a regra combinada" data-teste={`${teste}-descricao`} />
        </label>
      )}
    </div>
  );
}
